import { Spin } from 'antd'
import SearchBar from 'components/SearchBar'
import { ComponentTemplateItem } from 'features/rightDrawer/drawerStates/crudWorkflows/editRichAssetModel/templates/ComponentTemplateItem'
import { useState } from 'react'
import styled from 'styled-components'
import { GeckoAssetModel, GeckoComponentModel } from 'types'

const StyledSearchBar = styled(SearchBar)`
  margin-bottom: 0.625rem;
`

const TabContainer = styled.div`
  position: relative;
`

const Hint = styled.div`
  color: ${({ theme }) => theme.forecast.secondaryText};
`

const ComponentTemplatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`

const LoadingOverlay = styled.div`
  position: absolute;
  backdrop-filter: blur(2px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

interface ComponentTemplatesProps {
  applicableTemplates: GeckoComponentModel[]
  isLoadingTemplates: boolean
  selectedComponent: GeckoComponentModel | undefined
  assetModel: GeckoAssetModel
  forceRefresh: () => Promise<void>
}

export const ComponentTemplatesTab = ({
  applicableTemplates,
  isLoadingTemplates,
  selectedComponent,
  assetModel,
  forceRefresh,
}: ComponentTemplatesProps) => {
  const [searchText, setSearchText] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  if (!selectedComponent) {
    return <Hint>No component selected.</Hint>
  }

  const filteredTemplates = applicableTemplates
    .filter((template) =>
      template.name.toLowerCase().includes(searchText.toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name))

  return (
    <TabContainer>
      {isLoadingTemplates ? (
        <Spin />
      ) : (
        <>
          {applicableTemplates.length === 0 ? (
            <Hint>No feature templates available for this component type</Hint>
          ) : (
            <>
              {isLoading ? (
                <LoadingOverlay>
                  <Spin />
                </LoadingOverlay>
              ) : null}
              <StyledSearchBar
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder='Search for a component template'
              />
              <ComponentTemplatesList>
                {filteredTemplates.map((templateComponent) => (
                  <ComponentTemplateItem
                    key={templateComponent.id}
                    templateComponent={templateComponent}
                    selectedComponent={selectedComponent}
                    assetModel={assetModel}
                    setIsLoading={setIsLoading}
                    forceRefresh={forceRefresh}
                  />
                ))}
              </ComponentTemplatesList>
            </>
          )}
        </>
      )}
    </TabContainer>
  )
}
